import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';
import renderComponentFromEl from '~/javascripts/utils/renderComponentFromEl';
import { Component, Fragment } from 'react';
import { unmountComponentAtNode } from 'react-dom';

class Modal extends Component {
  static defaultProps = {
    containerClassName: '',
    modalInnerClassName: '',
    disableHistory: false,
    disableClickOutsideToClose: false,
    disableEscapeToClose: false,
    hideCloseModal: false,
    onCloseCallback: null,
    onOpenCallback: null,
    autoOpen: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      toggleDisabled: false,
    };

    this.childComponentEls = [];

    if (!this.modalName()) {
      console.error(
        'Modal name error',
        `Missing name for modal on page ${window.location}`
      );

      Sentry.captureMessage('Missing name for Modal');
    }

    this.isModalMounted = false;
  }

  componentDidMount = () => {
    this.isModalMounted = true;
    this.handleHashChange();
    window.addEventListener('hashchange', this.handleHashChange);
    window.addEventListener('keydown', this.handleEscapeKeypress);
    window.addEventListener('CloseModal', this.handleCloseModalEvent);

    if (this.props.autoOpen) {
      if (this.props.autoOpenOnDesktopOnly) {
        if (!window.isMobile) {
          this.toggle(true);
        }
      } else {
        this.toggle(true);
      }
    }
  };

  componentWillUnmount() {
    this.isModalMounted = false;
  }

  toggleZendeskWidget = () => {
    if (
      typeof window.zEmbed !== 'undefined' &&
      typeof window.zEmbed.hide !== 'undefined' &&
      typeof window.zEmbed.show !== 'undefined'
    ) {
      this.state.show ? window.zEmbed.hide() : window.zEmbed.show();
    }
  };

  setToggleDisabled = (disabled, callback) => {
    if (callback === undefined) {
      this.setState({
        toggleDisabled: disabled,
      });
    } else {
      this.setState(
        {
          toggleDisabled: disabled,
        },
        callback
      );
    }
  };

  handleHashChange = () => {
    if (this.props.disableHistory) return;
    if (!this.state.show && this.hashMatchesModal()) this.toggle();
    if (this.state.show && window.location.hash === '') this.toggle();
  };

  handleEscapeKeypress = (event) => {
    if (
      event.keyCode === 27 &&
      this.state.show &&
      !this.props.disableEscapeToClose
    )
      this.toggle();
  };

  handleCloseModalEvent = (event) => {
    if (event.detail.modalId == this.props.modalId) {
      this.toggle();
    }
  };

  renderChildComponents = () => {
    Array.from(this.modal.querySelectorAll('[data-component]')).forEach(
      (el) => {
        this.childComponentEls.push(el);
        renderComponentFromEl(el);
      }
    );
  };

  unmountChildComponents = () => {
    this.childComponentEls.forEach((el) => {
      unmountComponentAtNode(el);
    });
  };

  modalName = () =>
    this.props.modalName ||
    (this.props.modalId !== undefined && this.props.modalId.replace('-', ' '));

  toggle = (show) => {
    if (this.state.toggleDisabled) return false;
    if (!this.isModalMounted) return false;

    this.setState(
      {
        show: typeof show === 'boolean' ? show : !this.state.show,
      },
      () => {
        this.toggleZendeskWidget();

        if (this.state.show) {
          this.renderChildComponents();
          this.scrollPosition = $(document).scrollTop();
          this.bodyMarginTop = $('body').css('margin-top');

          if (!this.props.disableHistory)
            window.location.hash = this.props.modalId;
          $('body').addClass('modal-open');
          $('body').css('margin-top', `-${this.scrollPosition}px`);
          $('[data-parsley-validate]').parsley();

          if (this.props.onOpenCallback) this.props.onOpenCallback();
          document.dispatchEvent(
            new CustomEvent('ModalOpened', {
              detail: {
                modalId: this.props.modalId,
              },
            })
          );

          const trackingInfo = {
            ...{
              name: this.modalName(),
              label: this.modalName(),
              utm: Cookies.get('maji_utm'),
            },
            ...this.props.trackingInfo,
          };

          window.track_event('Viewed Modal', trackingInfo);
        } else {
          this.unmountChildComponents();
          if (this.props.onCloseCallback) this.props.onCloseCallback();

          if (!this.props.disableHistory) window.location.hash = '';

          $('body').removeClass('modal-open');
          $('body').css('margin-top', this.bodyMarginTop);
          $(document).scrollTop(this.scrollPosition);

          document.dispatchEvent(
            new CustomEvent('ModalClosed', {
              detail: {
                modalId: this.props.modalId,
              },
            })
          );
        }
      }
    );
  };

  hashMatchesModal = () => window.location.hash == `#${this.props.modalId}`;

  render() {
    return (
      <Fragment>
        {this.state.show && (
          <div
            className={`modal ${this.props.containerClassName}`}
            onClick={(event) => {
              if (
                !this.props.disableClickOutsideToClose &&
                !this.modalInner.contains(event.target)
              )
                this.toggle();
            }}
            ref={(el) => (this.modal = el)}
          >
            <div
              className={`modal-inner ${this.props.modalInnerClassName}`}
              ref={(el) => (this.modalInner = el)}
            >
              {!this.state.toggleDisabled && (
                <div
                  className={`modal-close ${
                    this.props.hideCloseModal ? 'hidden' : ''
                  }`}
                  onClick={this.toggle}
                />
              )}
              {this.props.children}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default Modal;
